export const state = () => ({
  saleRateIndexingRuleList: [],
});
